import { useEffect, useRef } from "react";

export default function VideoPlayerMobile({ src, controls = false }) {
const bucketUrl = "https://storage.googleapis.com/sportynerd-bucket1";

  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          video.play().catch(() => {}); // catch needed for autoplay policy
        } else {
          video.pause();
        }
      },
      { threshold: 0.3 } // pause when 70% out of view
    );

    observer.observe(video);
    return () => observer.disconnect();
  }, []);

  return (
    <div style = { { display : "flex", width : "100%", alignItems : "center"} }>
      <video
      ref={videoRef}
      src={bucketUrl + src}
      muted
      loop
      playsInline
      controls={controls}
      style={{
        maxWidth: "280px",
        // aspectRatio: "9 / 16",
        margin: "0 auto",
        borderRadius: "40px",
        border : "8px solid var(--bg4)",
        overflow: "hidden",
      }}
      />
    </div>
  );
}